import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((_nuxtApp) => {
  const linebreaks = (value) => {
    if (!value) return ''
    const innerP = '</p><p>'
    // Ignore extra consecutive linebreaks
    const val = value
      .toString()
      .replace(/\n{4,}/g, innerP)
      .replace(/\n{3}/g, innerP)
      .replace(/\n{2}/g, innerP)
      .replace(/\n/g, innerP)
    return '<p>' + val + '</p>'
  }

  return {
    provider: {
      linebreaks,
    },
  }
})
